import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Registro() {
  const [form, setForm] = useState({ nombre: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    // Registro simulado: este proyecto es solo frontend de demostración.
    setError('');
    setSuccess(true);
  };

  return (
    <section className="section page-section auth-page">
      <div className="auth-card">
        <h1>Crear cuenta</h1>
        <p>Guarda tus proveedores favoritos y da seguimiento a tus cotizaciones.</p>
        {error && <p className="error-message">{error}</p>}
        {success ? (
          <p className="success-message">¡Cuenta creada con éxito! Ya puedes iniciar sesión.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label>
              Nombre completo
              <input required value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
            </label>
            <label>
              Correo electrónico
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </label>
            <label>
              Contraseña
              <input
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </label>
            <button type="submit" className="btn btn-primary btn-block">Crear cuenta</button>
          </form>
        )}
        <p className="auth-switch">
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
        </p>
      </div>
    </section>
  );
}
